import React from 'react'
import { Notification as Notify, NotificationGroup } from '@progress/kendo-react-notification';

interface INotification {
  children: any;
  type: 'success' | 'error' | 'warning' | 'info';
  // position: 'top' | 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  closeNotification: () => void;
}

const Notification = (props: INotification) => {
  const { children, type, closeNotification } = props;

  return (
    <NotificationGroup
      style={{
        right: 0, bottom: 0,
        zIndex: 99999,
        alignItems: "flex-start", flexWrap: "wrap-reverse"
      }}
    >
      <Notify
        type={{ style: type, icon: true }}
        onClose={closeNotification}
        closable={true}
      >
        {children}
      </Notify>
    </NotificationGroup>
  )
}

export default Notification